<template>
    <div>
      <div class="bg">
        <div class="row">
          <div class="col-2 col-sm-4 col-md-4 col-lg-4 col-xl-5"></div>
          <div class="col-10 col-sm-8 col-md-8 col-lg-8 col-xl-7 bg-container">
            <transition enter-active-class="animated bounceIn delay-4" leave-active-class="animated bounceOut" appear>
              <img src="@/assets/background/hexagon_3.png" class="my-bg-small pl-5 d-none d-xl-block" width="100%">
            </transition>
            <transition enter-active-class="animated fadeIn delay-2" leave-active-class="animated fadeOut" appear>
                <img src="@/assets/images/image.png" class="my-bg pl-5 d-none d-lg-block" width="100%">
            </transition>
          </div>
        </div>
      </div>
      <!-- <div class="bg">
        <div class="row">
          <div class="cold-md-12">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
            <svg viewBox='0 0 120 100' class="svg-2">
              <defs>
                <pattern id='image' width="1" height="1" viewBox="0 0 100 100" preserveAspectRatio="none">
                  <image xlink:href='~@/assets/images/b_bg2.jpg' width="100" height="100" preserveAspectRatio="none"></image>
                </pattern>
              </defs>
                <path d='M38,2 L82,2  A12,12 0 0,1 94,10 L112,44 A12,12 0 0,1 112,
                56L94,90A12,12 0 0,1 82,98L38,98A12,12 0 0,1 26,90L8,56A12,
                12 0 0,1 8,44L26,10A12,12 0 0,1 38,2' />
            </svg>
          </transition>
          </div>
        </div>
      </div> -->
      <!-- <div class="bg">
        <div class="row">
          <div class="cold-md-12">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
            <svg viewBox='0 0 120 100' class="svg-3">
              <defs>
                <pattern id='image' width="1" height="1" viewBox="0 0 100 100" preserveAspectRatio="none">
                  <image xlink:href='~@/assets/images/b_bg2.jpg' width="100" height="100" preserveAspectRatio="none"></image>
                </pattern>
              </defs>
                <path d='M38,2 L82,2  A12,12 0 0,1 94,10 L112,44 A12,12 0 0,1 112,
                56L94,90A12,12 0 0,1 82,98L38,98A12,12 0 0,1 26,90L8,56A12,
                12 0 0,1 8,44L26,10A12,12 0 0,1 38,2' />
            </svg>
          </transition>
          </div>
        </div>
      </div> -->
      <!-- <div class="bg">
        <div class="row">
          <div class="cold-md-12">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
            <svg viewBox='0 0 120 100' class="svg-4">
              <defs>
                <pattern id='image' width="1" height="1" viewBox="0 0 100 100" preserveAspectRatio="none">
                  <image xlink:href='~@/assets/images/b_bg2.jpg' width="100" height="100" preserveAspectRatio="none"></image>
                </pattern>
              </defs>
                <path d='M38,2 L82,2  A12,12 0 0,1 94,10 L112,44 A12,12 0 0,1 112,
                56L94,90A12,12 0 0,1 82,98L38,98A12,12 0 0,1 26,90L8,56A12,
                12 0 0,1 8,44L26,10A12,12 0 0,1 38,2' />
            </svg>
          </transition>
          </div>
        </div>
      </div> -->
      <!-- <div class="bg">
        <div class="row">
          <div class="cold-md-12">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
            <svg viewBox='0 0 120 100' class="svg-5">
              <defs>
                <pattern id='image' width="1" height="1" viewBox="0 0 100 100" preserveAspectRatio="none">
                  <image xlink:href='~@/assets/images/b_bg2.jpg' width="100" height="100" preserveAspectRatio="none"></image>
                </pattern>
              </defs>
                <path d='M38,2 L82,2  A12,12 0 0,1 94,10 L112,44 A12,12 0 0,1 112,
                56L94,90A12,12 0 0,1 82,98L38,98A12,12 0 0,1 26,90L8,56A12,
                12 0 0,1 8,44L26,10A12,12 0 0,1 38,2' />
            </svg>
          </transition>
          </div>
        </div>
      </div> -->
    </div>
</template>

<script>
export default {
}
</script>
